import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FunctionComponent } from 'react';

type CheckmarkCircleProps = {
    className?: string;
};

const CheckmarkCircle: FunctionComponent<CheckmarkCircleProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'checkmark-circle'}
            viewBox="0 0 250 250"
        >
            <circle cx="125" cy="126" r="91" fill="#ffffff" />
            <path d="M125 .3C56.1.3 0 56.4 0 125.3s56.1 125 125 125 125-56.1 125-125S193.9.3 125 .3zm-19.6 170.6l-43.8-43.3 12.7-12.8 31.6 31.2 76.7-70.2 12.2 13.3-89.4 81.8z" />
        </svg>
    );
};
export default CheckmarkCircle;
